module.exports = __webpack_public_path__ + "img/no_img_big.e6c4885a.png";